<div class="modal-header modal-header-forms-list" id="forms-list-modal-title">
    <h3 class="modal-title mt-md-3 mt-lg-0" id="modal-title" translate="SELECT_FORM_TITLE">
        <ng-content select="[selectionDetails]"></ng-content>
    </h3>
    @if (modalInstance) {
        <span class="close" (click)="modalInstance.hide()">&times;</span>
    }
</div>
<ng-container *ngrxLet="filteredFormList$; let filteredFormList">
    <div class="modal-body modal-body-forms-list" id="modal-body">
        <div class="d-block d-lg-none">
            <!-- For responsive screen -->
            @if (filteredFormList.isLoading || filteredFormList.downloadingAll) {
                <progressbar [striped]="true" [value]="downloadAllProgress$ | async"></progressbar>
            }
            @if (!filteredFormList.isLoading && filteredFormList.entries.length > 0) {
                @for (entry of filteredFormList.entries; track entry.id.formId) {
                    <pace-forms-list-entry
                        [entry]="entry"
                        [showAbortFormButton]="showAbortFormButtonInList(entry, filteredFormList)"
                        [showDocumentationLink]="showDocumentationLink"
                        [showRefreshXMLButton]="showRefreshXMLButton"
                        [userFrontId]="userFrontId"
                        (previewForm)="previewForm($event, entry)"
                        (abortForm)="abortForm($event, entry, filteredFormList)"
                        (openInstructions)="openInstructions($event, entry)"
                        (refreshXML)="refreshXML($event, entry)"
                        (editForm)="editForm($event, entry)"
                    ></pace-forms-list-entry>
                }
            }
            @if (!filteredFormList.isLoading && filteredFormList.entries.length === 0) {
                <div class="text-center" translate="SELECT_FORM_NO_FORMS_TO_DISPLAY"></div>
            }
        </div>
        <table class="table d-none d-lg-block">
            <thead>
                <tr>
                    <th translate="SELECT_FORM_TYPE_TITLE" class="type-column"></th>
                    <th translate="SELECT_FORM_TITLE_TITLE"></th>
                    <th translate="SELECT_FORM_PRINT_TITLE" class="printno-column"></th>
                    <th translate="SELECT_FORM_LOCKED_BY_TITLE" class="lockedby-column"></th>
                    <th translate="SELECT_FORM_STATUS_TITLE" class="status-column"></th>
                    <th
                        class="status-column-details"
                        [class.abortButtonVisible]="showAbortButtonColumn"
                        [class.documentationLinkVisible]="showDocumentationLink"
                        [class.refreshButtonVisible]="showRefreshXMLButton"
                    ></th>
                </tr>
            </thead>
            @if (filteredFormList.isLoading || filteredFormList.downloadingAll) {
                <progressbar class="mt-2" [striped]="true" [value]="downloadAllProgress$ | async"></progressbar>
            }
            <tbody>
                @if (!filteredFormList.isLoading && filteredFormList.entries.length > 0) {
                    @for (entry of filteredFormList.entries; track entry.id.formId) {
                        <tr (click)="previewForm($event, entry)" [ngClass]="entry | formListEntryCssClass">
                            <td class="type-column">
                                <span class="type-icon"><fa-icon [icon]="entry | formListIcon"></fa-icon></span>
                                {{ entry.typeLabel }}
                            </td>
                            <td class="title-word-wrapper">{{ entry.title }}: {{ entry.variant }}</td>
                            <td class="printno-column">{{ entry.id.formId }}</td>
                            <td class="lockedby-column">{{ entry.lockedBy }}</td>
                            <td class="status-column">
                                <span>{{ entry | formsListSubmitStatus | translate }}</span>
                            </td>
                            <td
                                class="status-column-details"
                                [class.abortButtonVisible]="showAbortButtonColumn"
                                [class.documentationLinkVisible]="showDocumentationLink"
                                [class.refreshButtonVisible]="showRefreshXMLButton"
                            >
                                <span>
                                    <!-- status icon: template or interim? -->
                                    @if (hasBeenLoadedFromTemplate(entry)) {
                                        <fa-icon [icon]="faCircle"></fa-icon>
                                    }
                                    @if (hasBeenLoadedFromInterim(entry)) {
                                        <fa-icon [icon]="faDotCircle"></fa-icon>
                                    }
                                </span>
                                <span>
                                    <!-- locked? -->
                                    <fa-icon [icon]="hasLock(entry) ? faLock : faUnlock"></fa-icon>
                                </span>
                                <span>
                                    <!-- downloaded or uploaded? -->
                                    @if (hasBeenUploaded(entry)) {
                                        <fa-icon [icon]="faCloudUpload"></fa-icon>
                                    }
                                    @if (!hasBeenUploaded(entry) && !entry.cached) {
                                        <fa-icon [icon]="faCloud"></fa-icon>
                                    }
                                    @if (!hasBeenUploaded(entry) && entry.cached) {
                                        <fa-icon [icon]="faCloudDownload"></fa-icon>
                                    }
                                </span>
                                <!-- Abort form-->
                                @if (showAbortFormButtonInList(entry, filteredFormList)) {
                                    <button
                                        class="btn btn-small btn-secondary me-1"
                                        [disabled]="disableAbortButton(entry)"
                                        (click)="abortForm($event, entry, filteredFormList)"
                                        [attr.aria-label]="
                                            ('F4M_LIST_ABORT_FORM_ARIA_LABEL' | translate) + entry.id.formId
                                        "
                                    >
                                        <fa-icon [icon]="faMinusCircle"></fa-icon>
                                    </button>
                                }
                                <!-- instructions documentation-->
                                @if (showDocumentationLink) {
                                    <button
                                        class="btn btn-small btn-secondary me-1"
                                        (click)="openInstructions($event, entry)"
                                        [attr.aria-label]="
                                            ('F4M_LIST_OPEN_INSTRUCTIONS_ARIA_LABEL' | translate) + entry.id.formId
                                        "
                                    >
                                        <fa-icon [icon]="faFilePdf"></fa-icon>
                                    </button>
                                }
                                <!-- Refresh XML -->
                                @if (showRefreshXMLButton) {
                                    <button
                                        class="btn btn-small btn-secondary me-1"
                                        (click)="refreshXML($event, entry)"
                                        [attr.aria-label]="
                                            ('F4M_LIST_REFRESH_XML_ARIA_LABEL' | translate) + entry.id.formId
                                        "
                                    >
                                        <fa-icon [icon]="faSyncAlt"></fa-icon>
                                    </button>
                                }
                                <!-- open in edit mode -->
                                <button
                                    class="btn btn-small btn-secondary"
                                    [disabled]="hasBeenUploaded(entry)"
                                    (click)="editForm($event, entry)"
                                    [attr.aria-label]="('F4M_LIST_EDIT_FORM_ARIA_LABEL' | translate) + entry.id.formId"
                                >
                                    <fa-icon [icon]="faPencil"></fa-icon>
                                </button>
                            </td>
                        </tr>
                    }
                }
                @if (!filteredFormList.isLoading && filteredFormList.entries.length === 0) {
                    <div class="text-center" translate="SELECT_FORM_NO_FORMS_TO_DISPLAY"></div>
                }
            </tbody>
        </table>
    </div>
</ng-container>
<ng-container *ngrxLet="formList$; let formList">
    <div class="modal-footer modal-footer-forms-list">
        @if (!formList.isLoading && formList.entries.length > 0) {
            <div class="d-flex gap-2 justify-content-end">
                @if (showLanguageSelectionDropdown) {
                    <div class="btn-group" dropdown [dropup]="true">
                        <button
                            id="button-autoclose1"
                            dropdownToggle
                            type="button"
                            class="btn btn-primary dropdown-toggle"
                            aria-controls="dropdown-autoclose1"
                            [attr.aria-label]="'F4M_LIST_SELECT_LANGUAGE_ARIA_LABEL' | translate"
                        >
                            <span class="d-none d-lg-inline">{{ selectedLanguageKey$ | async }}</span>
                            <span class="d-inline d-lg-none"><fa-icon [icon]="faGlobe"></fa-icon> </span>
                            <span class="caret"></span>
                        </button>
                        <ul
                            id="dropdown-autoclose1"
                            *dropdownMenu
                            class="dropdown-menu"
                            role="menu"
                            aria-labelledby="button-autoclose1"
                        >
                            @for (language of formLanguages$ | async; track language) {
                                <li role="menuitem">
                                    <a class="dropdown-item" (click)="selectLanguage(language)">{{
                                        getLanguageKey(language)
                                    }}</a>
                                </li>
                            }
                        </ul>
                    </div>
                }
                <!-- Enable the button below for debugging purposes -->
                @if (isMockMode) {
                    <button class="btn btn-primary" (click)="deleteCachedForms()">
                        <span class="d-none d-lg-inline"> {{ 'SELECT_FORM_DELETE_CACHE' | translate }}</span>
                        <span class="d-inline d-lg-none"><fa-icon [icon]="faTrashAlt"></fa-icon> </span>
                    </button>
                }
                <!-- Container to pass in buttons from outside of pace forms -->
                <ng-content></ng-content>
            </div>
        }
    </div>
</ng-container>
